import { AbstractControl, FormControl, Validators } from "@angular/forms";
import { Product } from "./product.schema";

export class ProductPriorityListSchema {

    public static validation(profile = false): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            product: new FormControl('', Validators.required),
            province: new FormControl('', Validators.required),
        }
        return validator;
    }

    public static readonly validationMessages = {
        'product': [{ type: 'required', message: 'Obbligatorio' }],
        'province': [{ type: 'required', message: 'Obbligatorio' }],
    }

    constructor(
        public id?: number,
        public product?: Product,
        public province?: any,
    ){}

}